export const getLoadingAssetsToLoad = () => {
	const assets = new Array(7).fill('a').map((a, i) => `cloud_${i + 1}`);
	return assets;
};